export default {
  fade: true,
  speed: 250,
  dots: true,
  arrows: false,
  slide: '.views-row',
};



// WEBPACK FOOTER //
// ./Settings.Featured.js